import { parsePhoneNumber } from "libphonenumber-js";
import {
	US_RECENT_BOOKINGS,
	US_SITE_POPULAR_ARRIVAL,
	US_SITE_POPULAR_DEPARTURE,
} from "../constants/Options";
import { usaPopularDestination } from "../containers/redesign/homepage/constant";

export const US_CONSTANT = {
	stripePublicKey: process.env.REACT_APP_STRIPE_PK_US,
	placesAutocompletedLocation: {
		lat: 31,
		lng: -100,
	},
	addressCountry: "United States",
	billingAddressSelectStates: "US",
	getPaymentFrequency: "Bi-weekly",
	passportOrigin: "US",
	bookingsEmail: "support@paylatertravel.com",
	trustpilot: {
		locale: "en-US",
		businessUnitID: "6023a4aac0f73e00011dcb3e",
		link: "https://www.trustpilot.com/review/paylatertravel.com",
	},
	homeflightMockup: "assets/images/paylaterflightswebusa.png",
	countryCode: "102",
	currencyCode: "USD",
	supportMail: "support@paylatertravel.com",
	formikMuiDateFormat: "MM/DD/YYYY",
	cardRental: "https://www.gotrentalcars.com/us-label/?agence_id=5890",
	gaMeasurementId: "G-P3RJJR6Z0Z",
	popularDestination: usaPopularDestination,
	popularDepartureDestination: US_SITE_POPULAR_DEPARTURE,
	popularArrivalDestination: US_SITE_POPULAR_ARRIVAL,
	dateOfBirthExample: "12/30/1997",
	phoneInputCountryCode: "US",
	formatPhoneNumber: (phoneNumber) => {
		try {
			const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
			return parsedPhoneNumber.formatInternational();
		} catch (_) {
			const phoneFormat = phoneNumber
				?.replace(/\D/g, "")
				.match(/(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})/);
			if (!phoneFormat) {
				return "";
			}
			return !phoneFormat[2]
				? phoneFormat[1]
				: `+${phoneFormat[1]} (${phoneFormat[2]})${phoneFormat[3] ? ` ${phoneFormat[3]}-${phoneFormat[4]}` : ""}`;
		}
	},
	footerBrands: "/assets/redesign/icons/footer_stripe-us.svg",
};
